import { Injectable } from '@angular/core';
import { ListViewQuickFilterKeysService } from '@y42/core/list-view';
import { OrgSpaceQuery } from '@y42/org-space/state';
import { UserQuery } from '@y42/user/state';

@Injectable({ providedIn: 'root' })
export class Y42ListViewQuickFilterKeysService extends ListViewQuickFilterKeysService {
  constructor(private readonly userQuery: UserQuery, private readonly orgSpaceQuery: OrgSpaceQuery) {
    super();
  }

  getPrivateQuickFilterKey(): string {
    return `${this.userQuery.getActiveUserId()}`;
  }

  getPublicQuickFilterKey(): string {
    return this.orgSpaceQuery.getActiveId() || 'n/a';
  }
}
